const A2F_LIPSYNC_MODELS = [
    "ec6c5b20-8ac6-42bd-b291-f248cb3f0ebc", // Felix Klein
    "8f67d579-41c2-456d-900b-fccbcbf46bd3", // François Viète
    "2db1d398-0161-46cd-8aff-53008d29a9dc", // Claude Shannon
    "e97568c5-1daa-4a95-b4ae-0fe374c6b083", // Marcus Aurelius
    "c4b9ac58-a66a-451e-b035-afabd8be50b9", // Aristotle
    "d13b5a81-ed77-4a25-8a01-a76a0165b349", // Archimedes
    "ece0ab37-37c1-4ead-8222-fbb5b185dbe2", // Alessandro Volta
    "c73fed54-81e3-46ec-9d7c-3d11d05b142d", // Eratosthenes
    "3140d634-c7ca-4bda-af36-e1b49978b201", // Thomas Bayes
    "e3428624-bd1e-48b9-ae8c-c66ba68879cc", // George Boole
    "ca6ebdca-5151-4a58-8523-56d25fce5dfa", // William Playfair
    "78376372-3d71-4fce-8650-82b5be2c006b", // Diophantus
    "a2a43496-9a83-4444-813e-18a1930296e6", // Omar Khayyam
    "e617290b-bda0-4771-91ac-3fe6939dd412", // Benjamin Franklin
    "2707ca40-df64-4258-97c8-67d3695e8a42", // Brahmagupta
    "5a39bed2-a551-4a03-98a2-46104a3324bf", // Leonhard Euler
    "c93478a1-ed2f-4f1a-81f6-3fa474a21566", // Joseph-Louis Lagrange
    "94b6efbe-0aaa-47c7-bd3f-6d4f441d767f", // Grace Hopper
    "127cd993-f16e-4659-84fa-882cba633097", // Galileo Galilei
    "7f61d092-99e4-48e6-bf80-7aa2b7bd98ff", // Carl Friedrich Gauss
    "c0063a05-916b-45d0-bc2c-c63210414b17", // Ada Lovelace
    "3841a6bb-f977-453d-92f5-6cec1267546f", // Sigmund Freud
    "14836d13-ace6-4bf8-be26-26fbb80ed9bc", // Socrates
    "6bcf3678-e232-46c9-996a-67beb3fd2dbf", // Al-Khwarizmi
    "191e6103-a42c-4132-926c-230e7b1be5b6", // Jacob Bernoulli
    "5802e813-e715-491d-a0fd-92dc643c458e", // Blaise Pascal
    "f9f3f836-00c6-4160-8416-4b71b53f1307", // Srinivasa Ramanujan
    "7c7ac397-c36e-4218-92d4-f437d1959cca", // Euclid
    "278dddd6-b4a8-4303-a41d-be6219dbc907", //Albert Einstein
    "59c67a42-8c1e-45b8-aa41-b6fe6b3f5629", //George Orwell
    "bc5d31a8-047b-4f72-8f16-fea7a365ca69", //Richard Feynman
    "5eb1ad8d-4c11-4174-b79a-c232991d015b", //Oppenheimer
    "93ea7051-9722-443d-90fb-18a84c51894c", //James Clerk Maxwell
    "b20dc26f-8924-4aee-9ef5-9b98c0367a34", //Ernest Hemingway
    "897eb00c-4f16-4f73-81d5-d1c91fad53f2", //Charles Darwin
    "73f610bf-d9c9-4d9f-a026-a10086a66725", //Marie Curie
    "802bd089-d231-4c4e-830c-476199321af8", //Niels Bohr
    "031f2eea-64e5-441d-a37d-03d260cc43dc", //Abraham Lincoln
    "e3f55c33-3ff0-471f-b833-b59d7b145fc6", //Al Capone
    "2baa0479-7e38-4473-a2f2-1ad54149dbac", //Muhammad Ali
    "3f14429d-b2d4-4b99-8a05-58eed567c0d3", //Mansa Musa
    "8944783c-2e2b-4796-b92e-21dacca776bc", //Leonardo da Vinci
    "88c314c4-5890-4e55-9418-8b46a376ef81a", //Friedrich Nietzsche
    "4d7d2e17-b818-4144-b78b-629c688a71ac", //Karl Marx
    "581e7293-43cf-45ea-9fb3-0955c563cbe2", //Genghis Khan
    "7021ffd6-51bb-41a8-920e-935899dcd631", //Newton
    "992e9007-b4f8-4711-80c2-884daf3d9960", //Van Gogh
    "44f87c0b-ca22-4225-9fea-8d823e6a0160", //Warren
    "770e2d93-a6a4-41ed-aca1-8951327885b5", // Amelia Earhart
    "d75e63e0-2b2b-43ef-933f-589e8d6818c0", // Salvador Dali
    "a59fe2c1-9046-405a-9a99-a7ddbaee13be", //Adam Smith
    "d537d61d-0313-421b-ae66-48a8d7222b3f", //Tesla
    "5a42d57c-6e2b-4ba8-bd32-838a1a5c5e6b", //Machiavelli
    "5a16ff56-6e03-414e-a89d-cda9d83fae60", //Henry Ford
    "d6e3a3f1-d31e-4aab-8dd0-8b820932bd13", //Enrico Fermi
    "3542f19e-4e07-4828-8f9d-f330e4d6d660", //Plato
    "4f50a698-6034-49c1-b9d4-221f59bf2378", //Frida Kahlo
    "91d5cec5-1c21-423f-bbb4-bceb0f77a6c9", //Nostradamus
    "be0dcf0f-c72b-48f7-a462-6ba7560498d7", //Alan Turing
    "16f5b6a1-45f6-4c01-a612-60d4e4ab2297", //René Descartes
    "b8951237-698b-42b5-8b6e-ee381b91fb65", //Confucius
];

export function shouldUseA2FLipSync(modelId) {
    if (!modelId) return false;
    let useA2F = A2F_LIPSYNC_MODELS.includes(modelId);
    if (!useA2F) {
        // Doc-born characters (character_documents control plane, Task #413)
        // are enrolled via the injected payload — lip-sync on unless the
        // document explicitly opts out (lipSync: false).
        try {
            const d = (window.__docCharacters || {})[modelId];
            if (d) useA2F = d.lipSync !== false;
        } catch (e) {}
    }
    if (useA2F) {
        console.log(`[A2FConfig] Model ${modelId} configured for A2F lip sync`);
    }
    return useA2F;
}
